import { stimulusApplication } from "web-ui/controllers"

// The notices stream action delivers all notices in one payload. It looks up the
// `notices` controller on #notices and hands it the incoming notice elements to
// merge. The replace-actions attribute carries the merge's replaceActions
// option. See controllers/notices.js and controllers/notice.js.
function notices() {
  const container = document.getElementById("notices")

  if (container == null) {
    return
  }

  const controller = stimulusApplication.getControllerForElementAndIdentifier(
    container,
    "notices"
  )

  if (controller == null) {
    return
  }

  const incoming = [...this.templateContent.querySelectorAll(".notice")]
  const replaceActions = this.getAttribute("replace-actions") === "true"

  controller.merge(incoming, { replaceActions })
}

export function activate(Turbo) {
  Turbo.StreamActions.notices = notices
}
